import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

/* Baseline, not center: once the trail wraps, "Clear all" stays level with
   its first line instead of floating to the middle of the block. */
export const ContextRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${spacing[4]};
  min-width: 0;
`;

/* Wraps whole crumbs onto the next line, so the trail never sets a minimum
   width wider than its container. */
export const BreadcrumbList = styled.ol`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing[2]};
  min-width: 0;
  margin: 0;
  padding: 0;
  list-style: none;
`;

/* Label text may wrap only when a single crumb is wider than the whole row;
   otherwise the flex-wrap above moves the crumb down intact. */
export const BreadcrumbItem = styled.li<{ $isInteractive?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[2]};
  min-width: 0;
  ${({ $isInteractive }) =>
    $isInteractive ? typographyMixin("body", 3) : typographyMixin("body", 4)}
  color: ${({ $isInteractive }) =>
    $isInteractive ? rawColors.text.interactive : rawColors.text.highEmphasis};
  overflow-wrap: anywhere;

  & > button {
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    line-height: inherit;
    text-decoration: none;
    cursor: pointer;
  }

  & > button:focus-visible {
    outline: 2px solid ${rawColors.primary[300]};
    outline-offset: 0.125rem;
    border-radius: ${borderRadius.sm};
  }
`;

/** A crumb's leading glyph: 0.875rem, in the crumb's text colour, a gap before the label. */
export const CrumbIcon = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  margin-right: ${spacing[1]};
  vertical-align: middle;
  color: currentColor;

  & > svg {
    width: 0.875rem;
    height: 0.875rem;
  }
`;

export const BreadcrumbSeparator = styled.span`
  display: inline-flex;
  color: ${rawColors.text.mediumEmphasis};
`;

export const ClearAllButton = styled.button`
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: none;
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.mediumEmphasis};
  text-decoration: underline;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${rawColors.primary[300]};
    outline-offset: 0.125rem;
    border-radius: ${borderRadius.sm};
  }
`;
